module.exports = __webpack_public_path__ + "img/p3c.02086d16.png";